import { render, staticRenderFns } from "./NewUserProfile.vue?vue&type=template&id=a86f97d8"
import script from "./NewUserProfile.vue?vue&type=script&lang=js"
export * from "./NewUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports